import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import {
  useArchivalCollectionsList,
  useArchivalAidsList,
} from 'components/grid/grid-api';
import React from 'react';
import SearchSelectWithRadioRemote from '../form-components/search-select-with-radio-remote';
import { useSearchContext } from '../context/search-context';
import { SearchEntityEnum } from './search-v3-types';
export default function SearchV3CollectionsAndAidsSelects() {
  const { validSearchSpace } = useSearchContext();

  const aidsSearch = validSearchSpace.includes(SearchEntityEnum.ARCHIVAL_AID);
  const collectionSearch = validSearchSpace.includes(
    SearchEntityEnum.ARCHIVAL_COLLECTION
  );
  return (
    <>
      <Box display="flex" justifyContent="center" position="relative">
        {aidsSearch && collectionSearch && (
          <Box
            display="flex"
            justifyContent="center"
            style={{
              border: '1px solid #999',
              minWidth: 300,
              height: 50,
              transform: 'translateY(10px)',
              zIndex: 0,
              borderBottom: 'none',
            }}
          >
            a současně
          </Box>
        )}
      </Box>
      <Grid container spacing={2} style={{ position: 'relative' }}>
        {collectionSearch && (
          <Grid item xs={12} md={6}>
            <Paper style={{ padding: 16 }}>
              <SearchSelectWithRadioRemote
                formKey="selectedCollections"
                label="Fondy:"
                labelExclude="Vynechat fondy z vyhledávání"
                labelInclude="Omezit vyhledávání na fondy"
                useList={useArchivalCollectionsList}
                placeholder="Nyní se vyhledává ve všech fondech"
              />
            </Paper>
          </Grid>
        )}

        {aidsSearch && (
          <Grid item xs={12} md={6}>
            <Paper style={{ padding: 16 }}>
              <SearchSelectWithRadioRemote
                placeholder="Nyní se vyhledává ve všech pomůckách"
                formKey="selectedAids"
                label="Pomůcky:"
                labelExclude="Vynechat pomůcky z vyhledávání"
                labelInclude="Omezit vyhledávání na pomůcky"
                useList={useArchivalAidsList}
              />
            </Paper>
          </Grid>
        )}
      </Grid>
    </>
  );
}
